export default __webpack_public_path__ + "static/media/hero4.23b7586d.png";